<script>
  import Layout from "./components/Layout.svelte";
  import Editor from "./components/Editor.svelte";
  import WaitingFor from "./components/WaitingFor.svelte";
  import Hierarchy from "./components/Hierarchy.svelte";
  import NodeConfiguration from "./components/NodeConfiguration.svelte";
  import Container from "./components/Container.svelte";
  import Button from "./components/Button.svelte";
  import NotebooksContainer from "./components/NotebooksContainer.svelte";
  import SharePanel from "./components/SharePanel.svelte";
  import RunContainer from "./components/RunContainer.svelte";
  import Sandboxed from "./components/Sandboxed.svelte";

  export let path;
  export let user;
  export let router;

  const TIMEOUT = 10; // seconds
  let newData, newMetadata, editor, oldPath, node;

  $: (async () => {
    if (path != oldPath) {
      oldPath = path
      node = undefined
      node = await user.get('/'+path)
      window.node = node;
    }
  })()
  const saveContent = async (node) => {
    if (newMetadata?.run?.type === 'code') {
      node = await node.put_code(newData, (newMetadata.run.base_image.pkg_dependencies || []), newMetadata.run.base_image.name, newMetadata.run.cpus, 
        newMetadata.run.memory, newMetadata.run.gpu, newMetadata.run.idle_timeout, newMetadata.run.run_timeout, newMetadata.run.inject_node)
    } else {
      node = await node.put_data(newData, newMetadata.secret);
    }
  }
  
  // console.log(path, user)

  // user.get('/'+path).data.then(console.log)
</script>

{#if user}
  
  <Layout panels={[
    ['Config', '/assets/config.svg'],
    ['Run', '/assets/play.svg', 800, false, !newMetadata?.display],
    ['REPL', '/assets/repl.svg', 800, false, !node?._state.attributes.has('repl')],
    ['Docs', '/assets/docs.svg', 800], 
    ['Tests', '/assets/tests.svg', 800], 
    ['Share', '/assets/share.svg'], 
    // ['Sell', '/assets/dollar.svg'], 
  ]} updatable={path}>
    <Container slot='left'>
      {#await user.get('/'+path).children._timeout(TIMEOUT)}
        <WaitingFor />
      {:then children} 
        <Hierarchy path={path} children={children} mode='n' router={router} removeChild={node?._state?.methods?.has('remove') ? 
          async child => {await node.get(child).remove(); children = await user.get('/'+path).children._timeout(TIMEOUT)}
          : null}/>
      {:catch _}
        {router.replace('/x/'+path)}
      {/await}
    </Container>

    <div slot='main'>
      {#await Promise.all([user.get('/'+path).data._timeout(TIMEOUT), user.get('/'+path).metadata.to_dict()._timeout(TIMEOUT), user.get('/'+path)._timeout(TIMEOUT)])}
        {(() => {newMetadata = undefined})() || ''}
        <WaitingFor />
      {:then [data, metadata, node]} 
        {( newMetadata || (() => {newData = data || ''; newMetadata = metadata || {run: {type: 'data'}}; })() || '') && ''}
        <Container>
          {#if metadata?.editor}
            {#await node.get(metadata.editor)()._timeout(TIMEOUT)}
              <WaitingFor />
            {:then srcdoc}
              <Sandboxed srcdoc={srcdoc} params={{node: node}} />
            {/await}
          {:else}
            <Editor bind:data={newData} bind:editor={editor} language={newMetadata?.run?.type === 'data' ? 'json': newMetadata?.run?.base_image?.name === 'js'? 'js' : 'python'} 
              readOnly={!node._state.methods.has('put_code')} keyboardShortcuts={{'Ctrl-s': async () => {await saveContent(node);data = newData; metadata = newMetadata}}}/>
          {/if}
          <br/>
        </Container>
        <Button on:click={async () => {await saveContent(node);data = newData; metadata = newMetadata}} disabled={data === newData && JSON.stringify(metadata) === JSON.stringify(newMetadata)}>Save</Button>
      <!-- {:catch _}
        {router.replace('/x/'+path)} -->
      {/await}
    </div>

    <Container slot='0'>
      {#if newMetadata}
        <NodeConfiguration bind:metadata={newMetadata} />
      {/if}
    </Container>

    <RunContainer slot='1' node={node} display={newMetadata?.display}/>

    <NotebooksContainer slot='2' notebooksList={user.get('/'+path).repl} >
      <div style='line-height: 2em; margin-top: 50px'>
      Use REPL Notebooks to experiment with different snippets of code. <br> 
      Only users with "write" access to the node can see the REPL notebooks.

      </div>
    </NotebooksContainer>
    <NotebooksContainer slot='3' notebooksList={user.get('/'+path).docs}>
      <div style='line-height: 2em; margin-top: 50px'>
      Use Doc Notebooks to demonstrate how to use the service you created. <br> 
      Any user with at least "execute" access to the node can read the Docs notebooks.
      </div>
    </NotebooksContainer>
    <NotebooksContainer slot='4' notebooksList={user.get('/'+path).tests}>
      <div style='line-height: 2em; margin-top: 50px'>
      Use Test Notebooks to verify that your service behaves correctly. Commits are blocked until tests pass. <br> 
      Any user with at least "execute" access to the node can read the Tests notebooks.
      </div>
    </NotebooksContainer>
    <SharePanel slot='5' share={user.get('/'+path).share} />

  </Layout>
  <!-- {(() => {window.editor = editor;})() || ''} -->


{/if}


<style>
</style>